module.exports = __webpack_public_path__ + "static/media/group_.2daf7b61.svg";